import { httpClient } from '@/modules/common/services/http/http-client';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import {
  IWithdrawOptionsResponse,
  ICreateWithdrawResponse,
  IScheduleWithdrawalResponse
} from './types';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';

const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/banking/v1/cash`
});

const httpPlatform = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}`
});

export function getWithdrawOptions(): Promise<IWithdrawOptionsResponse> {
  const useNewEndpoint = FeatureFlagsModule.isEnabled(
    FeatureFlags.ENABLE_BFF_BANKING_MIGRATION
  );

  const httpClient = useNewEndpoint ? httpPlatform : http;
  const endpoint = useNewEndpoint
    ? '/transactions/v1/redemptions/withdraw-options'
    : '/getWithdrawOptions';

  return httpClient.get(endpoint);
}

export function createWithdrawal(
  bankAccountId: string,
  withdrawAmount: number
): Promise<ICreateWithdrawResponse> {
  return http.post('/createWithdrawal', {
    bankAccountId,
    withdrawAmount
  });
}

export function newCreateWithdrawal(
  bankAccountId: string,
  withdrawAmount: number
): Promise<ICreateWithdrawResponse> {
  return httpPlatform.post('/transactions/v1/redemptions/create-withdrawal', {
    bankAccountId,
    withdrawAmount
  });
}

export function scheduleWithdrawal(
  bankAccountId: string,
  withdrawAmount: number
): Promise<IScheduleWithdrawalResponse> {
  const useNewEndpoint = FeatureFlagsModule.isEnabled(
    FeatureFlags.ENABLE_BFF_BANKING_MIGRATION
  );

  const httpClient = useNewEndpoint ? httpPlatform : http;
  const endpoint = useNewEndpoint
    ? '/transactions/v1/redemptions/schedule-withdrawal'
    : '/scheduleWithdrawal';

  return httpClient.post(endpoint, {
    bankAccountId,
    withdrawAmount
  });
}
